import homePage from '@/components/homePage/index.vue';
export default {
  path: '/userInfo',
  component: homePage,
  redirect: '/userInfo/index',
  meta: { title: "系统管理" },
  children: [
    {
      path: "index",
      component: () => import('@/module/userInfoModule/viewPages/index.vue'),
      meta: { title: "用户信息" },
    }
  ]
}